var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgS1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7606 0H2.3925C1.11562 0 0 0.91875 0 2.18062V25.6006C0 26.8694 1.11562 28 2.3925 28H25.7537C27.0375 28 28 26.8619 28 25.6006V2.18062C28.0075 0.91875 27.0375 0 25.7606 0ZM8.67937 23.3394H4.66813V10.8675H8.67937V23.3394ZM6.8125 8.97125H6.78375C5.5 8.97125 4.66875 8.01562 4.66875 6.81938C4.66875 5.60125 5.52188 4.66813 6.83438 4.66813C8.14688 4.66813 8.95 5.59438 8.97875 6.81938C8.97813 8.01562 8.14688 8.97125 6.8125 8.97125ZM23.3394 23.3394H19.3281V16.52C19.3281 14.8863 18.7444 13.77 17.2931 13.77C16.1844 13.77 15.5281 14.52 15.2362 15.2506C15.1269 15.5131 15.0975 15.8706 15.0975 16.2356V23.3394H11.0863V10.8675H15.0975V12.6031C15.6812 11.7719 16.5931 10.5756 18.715 10.5756C21.3481 10.5756 23.34 12.3113 23.34 16.0531L23.3394 23.3394Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS1);
export default __webpack_public_path__ + "static/media/s1.93d47777d64123e2bc7e036cc531319b.svg";
export { ForwardRef as ReactComponent };